module.exports = __webpack_public_path__ + "static/media/diploma.5d992a7b.png";